<template>
  <div class="AssetSTatus">
    <div class="page-title">{{ title }}</div>
    <div>
      <div class="inline">
        <APeriodSelector 
          ref="period" 
          :value="search_period" 
          hide-select
          @change="handleChangePeriod" 
        />
      </div>
      <div class="inline">
        <el-button
          v-shortkey="['f5']"
          type="primary"
          value='0d'
          round          
          @shortkey.native="handleClickSearch"
          @click="handleClickSearch"
        >검색(F5)</el-button>
      </div>
    </div>
    <div class="flex">
      <div class="flex-fixed " style="width: 400px;">
        <ATable
          ref="table"
          v-loading="loading_balance"
          :data="balanceItems"          
          hide-button-insert
          hide-pagination
          highlight-current-row
          border
          @row-click="handleRowClick"
        >
          <el-table-column
            label="구분"
            prop="type_id"
            width="50"
            :formatter="resolveType"
          />
          <el-table-column
            label="계좌명"
            prop="account_id"
            :formatter="resolveAccount"
            show-overflow-tooltip
          />
          <el-table-column
            label="잔액"
            prop="balance"
            class-name="cell-number"
            width="100"
            :formatter="util.numberFormat"
          />
        </ATable>
      </div>
      <div class="pl-default" style="width: calc(100% - 410px);">
        <ATable          
          ref="table2"
          class="no-pointer"
          size="mini"
          :data="detailItems"
          :rowClassName="handleRowClassName"
          hide-button-insert
          hide-pagination
          border
        >
          <el-table-column
            type="index"
            label="No"          
            align="center"
            prop="index"
            :width="$width.index + 5"
            :index="handleIndex"
          />
          <el-table-column
            label="출납일자"
            prop="deal_date"
            :width="$width.date"
          />
          <el-table-column
            label="주계정"
            prop="parent_id"
            width="100"
            :formatter="resolveParentCategory"
          />
          <el-table-column
            label="부계정"
            prop="category_id"
            width="180"
            :formatter="resolveCategory"
          />
          <el-table-column
            label="상호"
            prop="customer_name"
            width="200"
          />
          <el-table-column 
            label="비고" 
            prop="desc"
            show-overflow-tooltip
          />
          <el-table-column
            label="수입액"
            prop="income"
            width="100"
            class-name="cell-number cell-income"
            :formatter="util.numberFormat"
          />     
          <el-table-column
            label="지출액"
            prop="expense"
            width="100"
            class-name="cell-number cell-expense"
            :formatter="util.numberFormat"
          />
          <el-table-column
            label="잔액"
            prop="balance"
            width="100"
            class-name="cell-number"
            :formatter="util.numberFormat"
          />
        </ATable>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "AssetSTatus",
  data() {
    return {
      title: this.$t("title.asset_status"),
      search_period: {value: '0d'},
      period: {},
      loading_balance: false,
      loading_detail: false,
      balance_items: [],
      detail_items: [],
      account_id: 0,
    }
  },
  mounted() {
    this.$nextTick(() => this.loadData());
  },
  computed: {
    ...mapGetters(["table_account", "table_asset_category", "table_customer"]),
    balanceItems() {
      return this.balance_items;
    },
    detailItems() {
      if (this.loading_balance || this.loading_detail) { return []; }
      let items = [];
      items = this.detail_items.filter(item => item.account_id === this.account_id);
      let income = 0, expense = 0, balance = 0;      
      items.forEach(item => {
        let customer = this.table_customer.find(c => c.id === item.customer_id)
        if (customer) {
          item.customer_name = customer.name;
        }
        income += item.income;
        expense += item.expense;
        balance = item.balance;
      });
      let account = this.balance_items.find(item => item.account_id === this.account_id);
      if (account && account.last_deal_date && account.last_balance) {
        items.splice(0, 0, {
          deal_date: account.last_deal_date,
          parent_id: "전일잔액",
          balance: account.last_balance,
        });
      }
      if (income > 0 || expense > 0) {
        items.push({
          is_sum: true,
          parent_id: "합 계",
          income: income,
          expense: expense,
          balance: balance,
        });
      }
      return items;
    },
  },
  methods: {
    loadData() {
      this.loading_balance = true;
      this.loading_detail = true;
      this.api.listAssetBalance(this.period).then(res => {
        this.balance_items = res.data;
        this.loading_balance = false;
      });
      this.api.listAsset(this.period).then(res => {
        this.detail_items = res.data;
        this.loading_detail = false;
      });
    },
    resolveType(row, column, value) {      
      let item = this.system.options.pay_way_flag.find(p => p.value == value)
      return item ? item.label : '';
    },
    resolveAccount(row, column, value) {      
      let item = this.table_account.find(c => c.id === value)
      return item ? item.name : '';
    },
    resolveParentCategory(row, column, value) {      
      if (value) {
        return value;
      }
      let item = this.table_asset_category.find(a => a.id === row.category_id);
      if (!item) { return '';}
      let parent = this.table_asset_category.find(a => a.id === item.parent_id);
      return parent ? parent.name : '';
    },
    resolveCategory(row, column, value) {
      let item = this.table_asset_category.find(a => a.id === value);
      return item ? item.name : '';
    },
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      if (!this.period.valid) { return; }
      this.loadData();
    },
    handleIndex(index) {     
      if (this.detailItems[index].is_sum) {
        return "";
      } else {
        if (this.detailItems.length === 1) {
          return 1;
        } else {
          return this.$refs.table2.indexResolver(index) - 1;
        }
      }    
    },
    handleRowClick(item) {
      this.account_id = item.account_id;
    },
    handleRowClassName({row}) {
      if (!row.is_sum) { return ''; }
      return 'warning-row';
    },
  },
}
</script>